module.exports = __webpack_public_path__ + "img/i9_logo_transparent.c51c7cc1.png";